import React from 'react';
import { List as MuiList, Paper } from '@mui/material';

const List = ({
  children,
  dense = false,
  disablePadding = false,
  subheader,
  variant = "default", // default, paper, outlined
  sx = {}
}) => {
  const listContent = (
    <MuiList
      dense={dense}
      disablePadding={disablePadding}
      subheader={subheader}
      sx={{
        width: '100%',
        bgcolor: 'background.paper',
        ...(variant === 'outlined' && {
          border: 1,
          borderColor: 'divider',
          borderRadius: 1
        }),
        ...sx
      }}
    >
      {children}
    </MuiList>
  );

  if (variant === 'paper') {
    return (
      <Paper elevation={1} sx={{ overflow: 'hidden' }}>
        {listContent}
      </Paper>
    );
  }

  return listContent;
};

export default List;
